export const H3 = ({ children }: { children: React.ReactNode }) => {
  return <h3 className='text-[40px] mt-10 font-medium text-gray-500'>{children}</h3>;
};

export const H4 = ({ children }: { children: React.ReactNode }) => {
  return <h4 className='text-xl leading-6 py-3 font-medium text-gray-600'>{children}</h4>;
};

export const P = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <p className={`mt-2 mb-6 max-w-[800px] font-sans ${className}`}>{children}</p>;
};

const MicrosoftImpactPartnerDescription = () => {
  return (
    <div className='w-[800px] font-normal font-open'>
      <H3>Welcome, Impact Entrepreneurs!</H3>
      <P>
        Microsoft and MovingWorlds have teamed up to give you personalized support to scale your
        revenue and impact — at no cost to you. Through this collaboration, you’ll gain access to
        the MovingWorlds Capacity-Building Platform, a trusted space designed to help strengthen
        business models, build new partnerships, and access the tools and expertise needed to grow
        your revenue and impact. Wherever you are on your path, this platform meets you where you
        are and helps you take the next leap forward.
      </P>
      <H3>What You’ll Gain Access To</H3>
      Once you register, you’ll gain always-on access to:
      <div className='w-[600px]'>
        <ul className='mb-10 list-disc pl-6'>
          <li className='mt-4'>
            <span className='font-semibold'>Support from top professionals:</span> Work with skilled
            volunteers from SAP, EY, and more—experts ready to help you implement real solutions to
            your biggest business challenges.
          </li>
          <li className='mt-4'>
            <span className='font-semibold'>Connections for growth:</span> Tap into a global network
            of investors, buyers, and partners that support social enterprises.
          </li>
        </ul>
      </div>
      <H3>How it works</H3>
      <P className='mb-6 font-sans'>
        A proven process — guided by technology and powered by real people who care about your
        growth.
      </P>
      <div className='w-[600px]'>
        <H4>Step 1 – Share Your Business Needs</H4>
        <P className='mb-6'>
          Tell us what challenge you’re working on — from marketing to business strategy, operations
          to data. We’ll use this information to understand your priorities and tailor your
          experience.
        </P>
        <H4>Step 2 – Post a Project</H4>
        <P className='mb-6'>
          Our simple tools make it easy to outline a project that fits your goals and schedule. This
          helps us find the right Experteer — a skilled professional ready to help you move forward.
        </P>
        <H4>Step 3 – Collaborate on a Solution</H4>
        <P className='mb-6'>
          Get hands-on support from pro bono experts from companies like SAP, EY, Lumen, F5, and
          more — plus access to tailored learning resources and events that help you grow
          sustainably.
        </P>
        <H4>Step 4 – Tap Into New Connections</H4>
        <P>
          When you’re ready, access curated introductions to funders, buyers, and ecosystem partners
          to help you expand your impact and scale your work.
        </P>
      </div>
      <H3>About the Microsoft + MovingWorlds Partnership</H3>
      <P>
        This collaboration brings together Microsoft’s commitment to empowering impact entrepreneurs
        with MovingWorlds’ expertise in social enterprise development. Together, we’re building a
        global ecosystem where innovation and purpose thrive side by side — enabling enterprises
        like yours to scale solutions that make a difference.
      </P>
    </div>
  );
};

export default MicrosoftImpactPartnerDescription;
